import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './demos.module.css';

/** Shape only. Every visible string is a locale key, so the demo speaks he/ar. */
const COURSE = {
  runs: [
    { id: 'r1', labelKey: 'march', sessions: [
      { id: 's1', labelKey: 's1', seats: 8, taken: 8 },
      { id: 's2', labelKey: 's2', seats: 8, taken: 6 },
    ] },
    { id: 'r2', labelKey: 'june', sessions: [
      { id: 's3', labelKey: 's1', seats: 10, taken: 3 },
      { id: 's4', labelKey: 's2', seats: 10, taken: 2 },
    ] },
  ],
};

/**
 * Course to run to session to seat.
 *
 * The seat is the atom — a place on one session, not a place "on the course" —
 * which is the whole reason two intakes of the same course can have different
 * capacity and fill independently.
 */
const CourseDemo = ({ color = '#8b5cf6' }) => {
  const { t } = useTranslation();
  const [openRun, setOpenRun] = useState('r1');
  const run = COURSE.runs.find((r) => r.id === openRun) || COURSE.runs[0];
  const seats = run.sessions.reduce((n, s) => n + s.seats, 0);
  const taken = run.sessions.reduce((n, s) => n + s.taken, 0);

  return (
    <div className={styles.demoFrame} data-demo="courses">
      <div className={styles.courseTitle} style={{ borderColor: `${color}44` }}>
        <span className={styles.coursePillLabel} style={{ background: `${color}18`, color }}>{t('demos.course.label')}</span>
        <strong>{t('demos.course.title')}</strong>
      </div>

      <div className={styles.courseRuns}>
        {COURSE.runs.map((r) => (
          <button
            key={r.id}
            type="button"
            data-testid="course-run"
            className={`${styles.courseRun} ${openRun === r.id ? styles.courseRunOn : ''}`}
            style={openRun === r.id ? { borderColor: color, background: `${color}0f` } : undefined}
            aria-pressed={openRun === r.id}
            onClick={() => setOpenRun(r.id)}
          >
            <span className={styles.courseRunLabel}>{t(`demos.course.${r.labelKey}`)}</span>
            <span className={styles.courseRunMeta}>{t('demos.course.sessions', { count: r.sessions.length })}</span>
          </button>
        ))}
      </div>

      <div className={styles.courseSessions}>
        {run.sessions.map((s) => (
          <div key={s.id} className={styles.courseSession}>
            <div className={styles.courseSessionHead}>
              <strong>{t(`demos.course.${s.labelKey}`)}</strong>
              <span className={styles.courseSessionCount}>
                {s.seats - s.taken === 0 ? t('demos.course.full') : t('demos.course.left', { count: s.seats - s.taken })}
              </span>
            </div>
            <div className={styles.courseSeats}>
              {Array.from({ length: s.seats }, (_, i) => (
                <span
                  key={i}
                  data-testid="course-seat"
                  className={styles.courseSeat}
                  style={{
                    background: i < s.taken ? color : 'transparent',
                    borderColor: i < s.taken ? color : '#cbd5e1',
                  }}
                  aria-hidden="true"
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.demoFoot}>
        <span className={styles.demoPill} data-testid="course-seatcount" style={{ background: `${color}18`, color }}>
          {t('demos.course.taken', { taken, seats })}
        </span>
        <span className={styles.demoPill} style={{ background: `${color}18`, color }}>
          {t('demos.course.atom')}
        </span>
      </div>
    </div>
  );
};

export default CourseDemo;
